import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import VehicleSectionsNav from '../VehicleSectionsNav';
import VehicleInfoAndBidsLaunch from './VehicleInfoAndBidsLaunch';
import PageBreadcrumb from '../../common/components/layout/PageBreadcrumb';
import { deleteBid, searchBids } from '../../bids/BidsActions';
import { useQueryString } from '../../common/helpers/queryString';

function VehicleBidsPage() {
  const dispatch = useDispatch();
  const query = useQueryString();
  const { id: auctionId } = useParams();
  const items = useSelector((state) => state.bids.get('items'));
  const auctionDetails = useSelector((state) => state.vehicles.get('auctionDetails'));
  const totalItems = useSelector((state) => state.bids.get('totalItems'));
  const [vehicleTitle, setVehicleTitle] = useState(null);

  useEffect(() => {
    if (auctionDetails?.basicData) {
      const { makeName } = auctionDetails.basicData;
      const { modelName } = auctionDetails.basicData;
      const { registrationPlate } = auctionDetails.basicData;
      setVehicleTitle(`${makeName} ${modelName}: ${registrationPlate}`);
    }
  }, [auctionDetails]);

  const [searchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
    auctionId: auctionId || null,
  });

  useEffect(() => {
    dispatch(searchBids(searchParams));
  }, [dispatch, searchParams]);

  const removeItemHandler = (bid) => {
    if (bid) {
      dispatch(deleteBid(bid.id)).then(() => {
        dispatch(searchBids(searchParams));
      });
    }
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'link', text: 'Vehicles', url: '/vehicles' },
    { id: 3, type: 'span', text: 'Vehicle bids' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Vehicle Bids" />
      <VehicleSectionsNav section="bids" />
      <VehicleInfoAndBidsLaunch
        bids={{ items, total: totalItems }}
        removeItemHandler={removeItemHandler}
        vehicleTitle={vehicleTitle}
      />
    </Container>
  );
}

export default VehicleBidsPage;
